import React, { Component } from 'react'

import _ from 'lodash';

import Typography from "@material-ui/core/Typography";

import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";

import style from "./DXFormStyles";
import ArrowDownload from '@material-ui/icons/ArrowDownward';
import { indexOfMax } from 'helpers/math';

export default class DXFormSectionTable extends Component {

  constructor(props) {
    super(props);

    this.state = {
      cellSelectionData: Array(this.props.section.rows.length).fill(undefined),
      sums: null
    }
  }

  static getDerivedStateFromProps(props, state) {
    if (props.valueState && props.valueState.cellSelectionData !== state.cellSelectionData) {
      return {
        cellSelectionData: props.valueState.cellSelectionData
      }
    }
    return null;
  }

  isValidated = async () => {
    const { section } = this.props;
    const { cellSelectionData } = this.state;
    const { columns } = section;
    const sums = Array(columns.length).fill(0);
    let valid = true;
    cellSelectionData.forEach((cellValue, i) => {
      if (cellValue !== undefined) {
        sums[cellValue] += 1
      } else {
        valid = false;
      }
    });

    console.log(`cellSelectionData = ${cellSelectionData}, sums = ${sums}`);
    await this.setState({ sums });

    if (!valid) {
      this.props.showAlertAction({
        message: `모든 값을 입력해줘야 합니다`,
        color: 'danger',
      })
      return false;
    }

    const top2 = _(sums).sortBy().takeRight(2).value();
    console.log('top2', top2);
    if (top2[0] === top2[1]) {
      this.props.showAlertAction({
        message: `값이 동점이 나와서 모호합니다. 지난 2주간 평균 능력 수준을 고려하여 선택을 조정해주세요.`,
        color: 'danger',
      })
      return false;
    }

    return true;
  }

  getData = () => {
    const { cellSelectionData, sums } = this.state;
    return {
      cellSelectionData,
      sums,
      활동수준: this.calc활동수준()
    }
  }

  renderTableHeader = (columns) => {
    return <GridContainer>
      <GridItem style={style.border1px} xs={4}>활동</GridItem>
      {
        columns.map(col => <GridItem style={style.border1px} xs={2} key={col}>{col}</GridItem>)
      }
    </GridContainer >
  }

  modifyText = (raw) => {
    const parts = raw.split("`");

    return <Typography
      style={{ whiteSpace: 'pre-line' }}>
      {
        parts.map((part, index) => {
          return index % 2 === 1 ? <u key={index}>{part}</u> : part
        })
      }</Typography>
  }

  renderTableRowInfo = (section, rowInfo, index) => {
    const { row: items } = rowInfo;
    return <GridContainer key={rowInfo.id}>
      <GridItem key={rowInfo.id} style={style.border1px} xs={4}>{index + 1}.{rowInfo.title}</GridItem>
      {
        items.map((row, rowIndex) => <GridItem
          key={row.id}
          onClick={(e) => {
            if (this.props.readOnly) {
              return;
            }
            const { cellSelectionData } = this.state;
            cellSelectionData[index] = rowIndex;
            console.log('data = ', cellSelectionData);
            this.setState({ cellSelectionData });
          }}
          style={this.state.cellSelectionData[index] === rowIndex ? style.border1pxPink : style.border1px} xs={2}>{this.modifyText(row.title)}</GridItem>)
      }
    </GridContainer>
  }

  renderTableFooterSum = () => {
    const { section } = this.props
    const { cellSelectionData } = this.state;
    const { columns } = section;
    const sums = Array(columns.length).fill(0);
    cellSelectionData.forEach((cellValue, i) => {
      sums[cellValue] += 1
    });

    return <GridContainer>
      <GridItem style={style.border1px} xs={4}>총 합계</GridItem>
      {
        sums.map((sum, i) => {
          return <GridItem
            key={i}
            style={style.border1px} xs={2}
          >{sum}</GridItem>
        })
      }
    </GridContainer>
  }

  calc활동수준 = () => {
    const { section } = this.props
    const { cellSelectionData } = this.state;
    const { columns } = section;
    const sums = Array(columns.length).fill(0);
    cellSelectionData.forEach((cellValue, i) => {
      sums[cellValue] += 1;
    });

    const index = indexOfMax(sums);


    return sums[index] < 1 ? 'N/A' : columns[index];
  }

  renderDescription = () => {

    return <React.Fragment>
      <GridContainer style={{ paddingTop: 20, paddingBottom: 20 }}>
        <table style={{ width: "100%" }}>
          <thead>
            <th style={style.border1pxHorizontal}>활동수준: 점검표를 작성한 후 가입하십시오.</th>
            <th style={{ ...style.border1pxHorizontal, textAlign: "center" }}>활동수준</th>
          </thead>
          <tbody>
            <tr>
              <td style={style.border1pxHorizontal}>
                <table>
                  <tr>
                    <td>
                      <ArrowDownload style={{ fontSize: 100 }} />
                    </td>
                    <td>
                      계획수준: 다양한 방법으로 활동<br />
                      탐색수준: 익숙한 방법으로 활동<br />
                      감각수준: 한 단계(one-step) 정도의 간단한 방법으로 활동<br />
                      반사수준: 감각자극에 반응<br />
                    </td>
                  </tr>
                </table>
              </td>
              <td style={{ ...style.border1pxHorizontal, textAlign: "center" }}>
                <h1>{this.calc활동수준()}</h1>
              </td>
            </tr>
          </tbody>
        </table>
      </GridContainer>
      <GridContainer style={{ paddingTop: 20, paddingBottom: 20 }}>
        <GridItem>완료 전에 지침을 읽으십시오.</GridItem>
        <GridContainer direction="column">
          <GridItem>
            <li><b><u>지난2주</u></b>를 생각하면서, 각 항목에서 대상자의 능력을 나타내는 문장에 체크표시 하십시오</li>
          </GridItem>
          <GridItem>
            <li>기준이 모호한 경우, 지난 2주 동안 평균 능력 수준을 선택하십시오</li>
          </GridItem>
          <GridItem>
            <li>각 항목에서 <u><b>하나의 설명만</b></u> 체크표시 해야 합니다.</li>
          </GridItem>
          <GridItem>
            <li>점검표 각 열 하단에 체크표시 한 것을 더하여 기록합니다.</li>
          </GridItem>
        </GridContainer>
      </GridContainer>
    </React.Fragment >
  }

  render() {
    const { pid, section } = this.props;
    const { rows, columns } = section;
    const id = pid ? `${pid}.${section.id}` : section.id;

    return (

      <React.Fragment>
        <GridContainer style={{ backgroundColor: "transparent" }}>
          {
            this.renderDescription()
          }
        </GridContainer>
        <GridContainer key={id} justify='center' style={{
          backgroundColor: "white"
        }}>
          {
            this.renderTableHeader(columns)
          }
          {
            rows.map((rowInfo, index) => this.renderTableRowInfo(section, rowInfo, index))
          }
          {
            this.renderTableFooterSum()
          }
        </GridContainer>
      </React.Fragment>
    )
  }
}
